import { Routes } from '@angular/router';
import { UnauthorizedPageComponent } from './pages/unauthorized-page/unauthorized-page.component';
import { PageNotFoundPageComponent } from './pages/page-not-found-page/page-not-found-page.component';
import { ServerErrorPageComponent } from './pages/server-error-page/server-error-page.component';
import { JobRequestListComponent } from './pages/home-page/job-request-list/job-request-list.component';
import { JobDetailsComponent } from './pages/job-details/job-details.component';
import { JobRequestDetailsComponent } from './pages/job-details/job-request-details/job-request-details.component';
import { PycnometerProfilesPageComponent } from './pages/pycnometer-profiles/pycnometer-profiles-page.component';
import { SampleManagerSearchPageComponent } from './pages/tools/sample-manager-search-page/sample-manager-search-page.component';
import { JobRequestSearchComponent } from './pages/tools/job-request-search/job-request-search.component';
import { MetricsPageComponent } from './pages/tools/metrics-page/metrics-page.component';
import { DynamicFormsListPageComponent } from './pages/tools/dynamic-forms/dynamic-forms-list-page/dynamic-forms-list-page.component';
import { DynamicFormDetailsPageComponent } from './pages/tools/dynamic-forms/dynamic-form-details-page/dynamic-form-details-page.component';
import { DynamicFormBuilderPageComponent } from './pages/tools/dynamic-forms/dynamic-form-builder-page/dynamic-form-builder-page.component';
import { DynamicFormRuntimePageComponent } from './pages/tools/dynamic-forms/dynamic-form-runtime-page/dynamic-form-runtime-page.component';

import { InventoryPageComponent } from './pages/inventory/inventory-page/inventory-page.component';
import { ChemicalsComponent } from './pages/chemicals/chemicals.component';
import { WorksheetPrintComponent } from './pages/worksheet-print/worksheet-print.component';
import { JobRequestWorksheetComponent } from './pages/job-request-work-sheet/job-request-work-sheet.component';
import { JobRequestReportComponent } from './pages/job-request-report/job-request-report.component';
import { JobRequestColumnReportComponent } from './pages/job-request-column-report/job-request-column-report.component';
import { TestDefinitionsListComponent } from './pages/tools/custom-test-definitions/list/test-definitions-list.component';
import { TestDefinitionComponent } from './pages/tools/custom-test-definitions/test-definition.component';
import { allowedChevronGroupGuard } from './services/auth/allowed-chevron-group.guard';
import { CalGuardService } from '@cvx/cal-angular';

export const routes: Routes = [
  { path: '403', component: UnauthorizedPageComponent },
  { path: '401', component: UnauthorizedPageComponent },
  { path: '404', component: PageNotFoundPageComponent },
  { path: '500', component: ServerErrorPageComponent },
  {
    path: '',
    canActivate: [CalGuardService, allowedChevronGroupGuard],
    children: [
      { path: '', redirectTo: () => `/jobs?year=${new Date().getFullYear()}`, pathMatch: 'full' },
      { path: 'jobs', component: JobRequestListComponent },
      { path: 'jobs/:id', component: JobDetailsComponent },
      { path: 'jobs/:jobId/requests/:id/report', component: JobRequestReportComponent },
      { path: 'jobs/:jobId/requests/:id/column-report', component: JobRequestColumnReportComponent },
      { path: 'jobs/:jobId/requests/:id', component: JobRequestDetailsComponent },
      { path: 'jobs/:jobId/worksheets/request/:requestId', component: JobRequestWorksheetComponent },
      { path: 'jobs/:jobId/worksheets/:testGroupId', component: WorksheetPrintComponent },
      { path: 'feature-tools/pycnometer-profiles', component: PycnometerProfilesPageComponent },
      { path: 'tools/sample-manager-search', component: SampleManagerSearchPageComponent },
      { path: 'tools/job-request-search', component: JobRequestSearchComponent },
      { path: 'tools/metrics', component: MetricsPageComponent },
      { path: 'feature-tools/sample-manager-search', redirectTo: 'tools/sample-manager-search' },
      { path: 'tools/dynamic-forms', component: DynamicFormsListPageComponent },
      { path: 'tools/dynamic-forms/new/builder', component: DynamicFormBuilderPageComponent },
      { path: 'tools/dynamic-forms/:id/details', component: DynamicFormDetailsPageComponent },
      { path: 'tools/dynamic-forms/:id/editor', redirectTo: '/tools/dynamic-forms/:id/builder' },
      { path: 'tools/dynamic-forms/:id/builder', component: DynamicFormBuilderPageComponent },
      { path: 'tools/dynamic-forms/:id/preview', redirectTo: '/tools/dynamic-forms/:id/runtime' },
      { path: 'tools/dynamic-forms/:id/runtime', component: DynamicFormRuntimePageComponent },
      { path: 'tools/dynamic-form', redirectTo: 'tools/dynamic-forms' },
      { path: 'feature-tools/dynamic-form', redirectTo: 'tools/dynamic-forms' },
      { path: 'feature-tools/dynamic-forms', redirectTo: 'tools/dynamic-forms' },
      { path: 'tools/custom-test-definitions', component: TestDefinitionsListComponent },
      { path: 'tools/custom-test-definitions/new', component: TestDefinitionComponent },
      { path: 'tools/custom-test-definitions/:id/edit', component: TestDefinitionComponent },
      { path: 'sample', component: InventoryPageComponent },
      { path: 'materials', component: ChemicalsComponent },
      {
        path: 'operational-dashboard',
        loadComponent: () =>
          import('./pages/operational-dashboard/operational-dashboard-page.component').then(
            (m) => m.OperationalDashboardPageComponent
          ),
        data: { hideAside: true }
      }
    ]
  },
  { path: '**', redirectTo: '404' }
];
